<template>
    
    <div class="popupbackdrop fixed left-0 top-0 w-full h-full z-10 ">
    
    </div>
    
</template>
<script setup>
    import { ref } from 'vue';
</script>

<style scoped>
    
    .popupbackdrop{
        background-color: rgba(171, 150, 112, 0.3);   
    }
</style>

